enum Colors {
  GREEN = 0x15cb07,
  ORANGE = 0xffa328,
  WHITE = 0xffffff,
  GREY = 0x313234,
  YELLOW = 0xd4ce22,
  BLUE = 0x47a3ff,
  PURPLE = 0x7122d5,
  DARK_GREY = 0x222222,
  DARKER_GREY = 0x1d1e20,
  DARK_ORANGE = 0x9b5900,
  BELT_ORANGE = 0xb96c21,
  RED = 0x990000,
}

export default Colors;
